import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LoadingModal } from '../../../component/LoadingModal/LoadingModal';
import { IDateiliste } from '../../../types/Types';
import LandingpageHeader from '../../header/LandingpageHeader';
import styles from '../admin.module.scss';
import { useGetTrashListAPIMutation, useRestoreFileMutation } from '../../../api/FileAPI';

export default function PapierkorbMain() {

  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [liste, setListe] = useState<IDateiliste[]>([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [getTrashListAPI] = useGetTrashListAPIMutation();
  const [restoreFileAPI] = useRestoreFileMutation();

  const init = () => {
    setIsLoaded(false);
    getTrashListAPI().unwrap()
      .then((data) => setListe(data))
      .catch((e) => console.log(e))
      .finally(() => setIsLoaded(true))
      ;
  }

  const restoreFile = (uid: string) => {
    setIsLoaded(true);
    restoreFileAPI({uid: uid}).unwrap()
      .then(() => init())
      .catch((e) => console.log(e))
      .finally(() => setIsLoaded(true))
      ;
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div className={classNames(styles.centerContainer)}>

        <LandingpageHeader />

        <LoadingModal show={!isLoaded} text={"Lade Papierkorb..."} />

        <div className='container' >

          <button
            onClick={() => {
              navigate({
                pathname: "/",
                search: ""
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          >
            <i className="bi bi-arrow-left"></i> {t('deTranslation.misc.backButton')}
          </button>


          <div className={styles['wg-detail-ueb']}>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>Papierkorb</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>

          <div style={{ display: "grid", fontWeight: "bold", gridTemplateColumns: "2fr 2fr 1fr 1fr 1fr 1fr", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
            <div>Dateiname</div>
            <div style={{ textAlign: "end" }}>
              Option
            </div>
          </div>
          {
            (isLoaded && liste?.map((e, index) =>
              <div key={index} style={{ display: "grid", gridTemplateColumns: "5fr 1fr", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
                <div>{e.filename}</div>
                <div style={{ textAlign: "end" }}>
                  <button className='btn btn-secondary-light' onClick={() => restoreFile(e.uid)} ><i className="bi bi-arrow-counterclockwise"></i> Wiederherstellen</button>
                </div>
              </div>)
            )
          }
        </div>
      </div>

    </>
  );
}